import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useGetEventForKids } from 'api/Events'
import Spinner from 'components/Spinner'
import { Empty, Pagination } from 'antd'
import usePagination from 'helper/usePagination'
import GlobalEventComponent from 'components/Events/Events'
import { useSyncParamsWithRoute } from 'hooks/useUpdateSearchParams'
import EventCard from 'components/Events/Views/CardView/SingleCard'
import EmptyData from 'components/global/EmptyData'

const KidEvents = () => {
  const { id }: any = useParams()
  const [params, setParams] = useState({
    page: undefined,
    limit: undefined,
  })
  const { updateRouteParams } = useSyncParamsWithRoute(params, setParams)
  const PaginationChanger = (pagenumber: number, limit: number) => {
    updateRouteParams({ page: pagenumber, limit: limit })
  }
  const { isLoading, isFetching, data, refetch } = useGetEventForKids(
    id,
    params,
  )

  useEffect(() => {
    if (params.page) {
      refetch()
    }
  }, [params])

  return (
    <div>
      <div className="bg-white p-30px">
        {isFetching || isLoading ? (
          <div className="bg-white flex justify-center align-center">
            <Spinner />
          </div>
        ) : data?.records?.length ? (
          <>
            {data.records.map((event: any) => {
              return <EventCard event={event} key={event._id} />
            })}
            <div className="mb-20px mt-20px">
              {(data?.hasNextPage || data?.hasPrevPage) && (
                <div className="text-right">
                  <Pagination
                    onChange={PaginationChanger}
                    defaultCurrent={params.page}
                    total={data.count}
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`
                    }
                    pageSize={params.limit || 10}
                    showSizeChanger={false}
                  />
                </div>
              )}
            </div>
          </>
        ) : (
          <div>
            <EmptyData message="No events" />
          </div>
        )}
      </div>
    </div>
  )
}

export default KidEvents
